import Modal from 'react-modal';
import React, { useEffect, useState, lazy, Suspense } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';

const OnDeffImplementation = lazy(() => import('./on-deff-implementation'))

const ServiceModalSelect = (props) => {
    const proId = props.proid;
    const [selectedValue, setSelectedValue] = useState("dumpster")
    const [loading, setLoading] = useState(false)
    const [selectService, setSelectService] = useState(true)
    const [ondeffCode, setOndeffCode] =useState('dumpsterQuoteRequest') 
    
    let initialValuePoolLimit = 0;
    if (typeof window !== 'undefined') {
        const params = new URLSearchParams(window.location.search)
        if (params.get("test") == "true") {
            initialValuePoolLimit = 1;
        }
    }
    const [limitPoolSize, setPoolTest] = useState(initialValuePoolLimit)
    

    const changeSelectedValue = (e) => {
        setSelectedValue(e.target.value);
    }

    const [showModal, setShowModal] = useState(false)
    const changeShowModal = () => {
        setSelectService(true);
        setShowModal(!showModal)
    }
    const [modalStyles, setModalStyles] = useState(
        {
            content:
            {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                borderRadius: '10px',
                border: 'none',
                backgroundColor: '#e8e8e8',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                padding: '0px 20px',
                width: '600px',
            }
        })

    const styles = {
        container: {
            marginTop: 15,
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'space-between',
        },
        radioText: {
            fontSize: 20,
            color: '#000',
            fontWeight: '700',
            verticalAlign: 'top'
        },
        radioCircle: {
            height: 20,
            width: 20,
            marginRight: 15,
            borderRadius: 100,
            borderWidth: 2,
            borderColor: 'red',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'red',
            color: "red"
        }
    };

    const nextStep = () => {
        setSelectService(false)
        if (selectedValue == "dumpster") setOndeffCode('dumpsterQuoteRequest')
        else setOndeffCode('junkRemovalQuoteRequest')
    }

    return (
        <>
            <div className="">
                <button style={{ cursor: 'pointer' }} className="profile-button-form" onClick={changeShowModal}>Get a Quote</button>
            </div>
            <Modal
                id={1}
                isOpen={showModal}
                style={modalStyles}
                contentLabel="Get a Quote!"
                shouldCloseOnOverlayClick={false}
                preventScroll={true}
                ariaHideApp={false}
            >
                { selectService && <><div className="modal-header">
                        <button type="button" className="close closermodal" onClick={changeShowModal} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div><div>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <h1 className='center'>What service do you need?</h1>
                            </div>
                            <div onChange={changeSelectedValue}>
                                <div style={styles.container}>
                                    <input id="dumpster" style={styles.radioCircle} type="radio" value="dumpster" checked={selectedValue === "dumpster"} />
                                    <label htmlFor="dumpster" style={styles.radioText}>Dumpster Rental</label>
                                </div>
                                <div style={styles.container}>
                                    <input id="junk-removal" style={styles.radioCircle} type="radio" value="junk-removal" checked={selectedValue === "junk-removal"} />
                                    <label htmlFor="junk-removal" style={styles.radioText}>Junk Removal</label>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-primary next" onClick={nextStep}>NEXT</button>
                            </div>
                        </div></>}

                        { !selectService && 
                        <><Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={loading}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop><div className="modal-header">
                            <button type="button" className="close closermodal" onClick={changeShowModal} aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div><div id="quote-steps-modal-library">
                          <Suspense fallback={<h1>Loading…</h1>}>
                            <OnDeffImplementation
                                initialData={[{ key: 'pro_id', value: proId }, { key: 'limit_poolsize', value: limitPoolSize }]}
                                formCode={ondeffCode}
                                loadingFunction={setLoading}>
                            </OnDeffImplementation>
                          </Suspense>
                        </div></>
                        }
            </Modal>

        </>

    )
}

export default ServiceModalSelect;